// extracted by mini-css-extract-plugin
export default {"wrapper":"V95hpymqy2oCGxTRoOCc","demo_buttons":"Bc1T4ct7YlTEPvdPbFDN","demo_buttons__button":"xP4jcpFWxVr3yN0TDONK","note":"aWmTZTHZWheyonZUKeoQ"};